import { render, staticRenderFns } from "./MiniBadge.vue?vue&type=template&id=2e818f12&scoped=true"
import script from "./MiniBadge.vue?vue&type=script&lang=js"
export * from "./MiniBadge.vue?vue&type=script&lang=js"
import style0 from "./MiniBadge.vue?vue&type=style&index=0&id=2e818f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e818f12",
  null
  
)

export default component.exports